import React from "react";
import Slider from "react-slick";
import { FiPhoneCall } from "react-icons/fi";
import { IoLocationSharp } from "react-icons/io5";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const slides = [
    {
      image: "/images/home/banner/banner-1.gif",
      title: "Pool Home Care",
      description: "Your Trusted Pool Partner",
      phone: "+91 8319579035",
      location: "Indore, India",
    },
    {
      image: "/images/home/banner/banner-2.jpg",
      title: "Luxurious Pool Designs",
      description:
        "Transform your backyard into a luxurious oasis with Pool Home Care's custom designs.",
        phone: "+91 8319579035",
      location: "Indore, India",
    },
    {
      image: "/images/home/banner/banner-3.jpg",
      title: "Custom Pool Solutions",
      description:
        "Tailor-made pool solutions for homes, resorts, and farmhouses. Trust Pool Home Care.",
        phone: "+91 8319579035",
      location: "Indore, India",
    },
    {
      image: "/images/home/banner/banner-4.jpg",
      title: "Professional Pool Maintenance",
      description:
        "Keep your pool sparkling clean with Pool Home Care's reliable maintenance services.",
        phone: "+91 8319579035",
      location: "Indore, India",
    },

    
  ];

  return (
    <div className="relative mt-4">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="relative h-screen">
            {/* Image */}
            <img
              src={slide.image}
              alt={slide.title}
              loading="lazy"
              className="w-full h-full object-cover"
            />
            {/* Overlay Content */}
            <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white text-center px-4">
              <h1 className="text-3xl md:text-5xl font-bold">{slide.title}</h1>
              <p className="mt-3 text-base md:text-xl">{slide.description}</p>
              <div className="mt-5 flex flex-col md:flex-row items-center gap-4 text-sm md:text-lg">
                <span className="flex items-center gap-2">
                  <FiPhoneCall className="text-xl" />
                  {slide.phone}
                </span>
                <span className="flex items-center gap-2">
                  <IoLocationSharp className="text-xl" />
                  {slide.location}
                </span>
              </div>
              <div className="mt-6 flex flex-col md:flex-row gap-4">
              <a href="/gallery">
                  <button className="px-6 py-2 bg-primary text-white rounded-md hover:bg-primary/90">
                    OUR PRODUCTS
                  </button>
                </a>
                <a href="/contact">
                  <button className="px-6 py-2 bg-white text-primary rounded-md hover:bg-primary/10">
                    MAKE AN ENQUIRY
                  </button>
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Hero;
